module.exports = __webpack_public_path__ + "media/promotional/canyoning-7d480c20.jpeg";